import api from '@/logic/api'

export default {
  getChallengingQuestions: () => api.get('/analytics/challenging-questions'),
  viewHome: () => api.post('/view/home'),
  getTopPlayers: () => api.get('/stats/players'),
  getTopTeams: () => api.get('/stats/quiz-teams'),
  getMyQuizStats: () => api.get('/stats/mine'),
}
